import script from "./OfEngageCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./OfEngageCampaign.vue?vue&type=script&setup=true&lang=js"

import "./OfEngageCampaign.vue?vue&type=style&index=0&id=ae12ccf4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae12ccf4"]])

export default __exports__